import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const AttributesQuery = gql`
  query attributes($ids: [String]) {
    attributes(where: { ids: $ids }) {
      id
      title
      type
      definition
      name
      slug
      priority
      isVisual
      tags
      isFilterable
      values {
        id
        title
        value
        colorHex
        slug
      }
    }
  }
`;

interface IInputProps {
  children?: any;
  ids?: Array<string>;
}

interface IResponse {
  data: any;
}

class GetAttributesQuery extends React.PureComponent<ChildProps<IInputProps, Response>> {
  public render() {
    const { attributes }: any = this.props;
    return this.props.children({
      attributes
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(AttributesQuery, {
    name: 'attributes',
    options: props => ({
      variables: {
        ids: props.ids
      }
    })
  })
)(GetAttributesQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Attributes/FilterableAttributes.tsx